module.exports.initializePendo = function initializePendo(user) {
  (function (p, e, n, d, o) {
    var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
      o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
    })(v[w]);
    y = e.createElement(n); y.async = !0; y.src = 'https://us1.cdn.pendo.io/agent/static/e2380527-a796-45bf-5d9d-a5441266d748/pendo.js';
    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');

  pendo.initialize({
    visitor: {
      id: `${location.hostname}-${user.id}`,            // Required if user is logged in, default creates anonymous ID
      email: user.email,                                // Recommended if using Pendo Feedback, or NPS Email
      full_name: `${user.firstName} ${user.lastName}`,  // Recommended if using Pendo Feedback
      // role:                                          // Optional

      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
      org_type: user.organizationType,
    },

    account: {
      id: user.organizationId,        // Required if using Pendo Feedback
      name: user.organizationName,    // Optional
      // is_paying:    // Recommended if using Pendo Feedback
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
      organizationCreated: user.organizationCreated,
      citizensOrgType: user.citizensOrgType,
      ...user.products
    }
  });
}